/** Radix Select forbids empty-string item values; use this for "clear" options. */
export const SELECT_NONE = '__none__';

export function fromSelectValue(v: string | undefined): string {
  return v && v !== SELECT_NONE ? v : '';
}

export function toSelectValue(v: string | undefined): string | undefined {
  return v && v.length > 0 ? v : undefined;
}
